import { useMutation, gql } from '@apollo/client';

export const DELETE_NOTIFICATION = gql`
  mutation deleteNotification($id: ID!) {
    deleteNotification(id: $id) @client
  }
`;

export default (options) => {
  return (
    useMutation(DELETE_NOTIFICATION, options)
  );
}
